<div
  class="wrap"
  [style.height]="(headerService.headerHeight$ | async) + 'px'"
></div>
